// @ts-expect-error $TSFixMeError: Could not find a declaration file for module 'escape-html'. 'C:/js/mews-js/node_modules/escape-html/index.js' implicitly...
import escapeHtml from 'escape-html';
import { reduce, trim } from 'lodash';

export const SimpleMarkdown = (
    { text, ...other }: $TSFixMe // text is sanitized
) =>
    // eslint-disable-next-line react/no-danger, @typescript-eslint/strict-boolean-expressions
    text ? <span {...other} dangerouslySetInnerHTML={{ __html: markdownText(text) }} /> : null;

const rules = [
    { regex: /\r\n/gm, replacement: '<br>' },
    { regex: /\n/gm, replacement: '<br>' },
];

const markdownText = (input: $TSFixMe) => {
    const sanitizedInput = escapeHtml(input);
    const markedText = reduce(rules, (text, rule) => text.replace(rule.regex, rule.replacement), sanitizedInput);
    return trim(markedText);
};
